import { DELETE_ALERT_V3 } from "fleet/redux-store/alerts-v3/actions";
import { alertsV3Selector } from "fleet/redux-store/alerts-v3/selectors";
import { AlertListPage } from "fleet/view/alert/list";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth";
import { makeGetAllAsArray } from "redux-store/selectors";
import { isAdmin, usersSelector } from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";

const getAlertsAsArray = makeGetAllAsArray();
const getUsersAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const storesLoaded = storesReady(state.app.alertsV3, state.global.users);
  const alertsById = alertsV3Selector(state);
  const alerts = getAlertsAsArray({ byId: alertsById });
  const usersById = usersSelector(state);
  const users = getUsersAsArray({ byId: usersById });
  const user = getAuthUser(state);
  const userIsAdmin = isAdmin(user);

  return {
    alerts,
    storesLoaded,
    users,
    isAdmin: userIsAdmin,
    v3: true,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteAlert: (alertId) => {
      return createPromiseApiAction(dispatch, DELETE_ALERT_V3, [alertId]);
    },
  };
}

const ConnectedAlertsListPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertListPage);

export { ConnectedAlertsListPage };
